import { CSSProperties } from 'react';
import { red } from 'globals/colors';

export const getFirstInfoBoxItemInRowStyle = (
  idx: number,
  isUpSm: boolean
): CSSProperties => {
  if (isUpSm)
    return {
      borderLeft: idx % 3 === 0 ? 0 : undefined,
      paddingLeft: idx % 3 === 0 ? 0 : undefined,
    };
  return {
    borderLeft: idx % 2 === 0 ? 0 : undefined,
    paddingLeft: idx % 2 === 0 ? 0 : undefined,
  };
};

export const getSingleBarGraphColor = (
  idx: number,
  colorArray: string[] = []
): string => {
  return colorArray[idx] || red.MAIN;
};

export const getFsSingleBarGraphStyle = (): CSSProperties => ({
  flex: '1 1 0px',
});
